import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackPromoOffersShow } from 'shared/containers/NewbuildingMortgageSection/tracking';

import { Promos } from './parts/Promos';
import { PromosBanner } from './parts/PromosBanner';
import { NewbuildingPromos } from '../../components/NewbuildingPromos';
import {
  getIsFromBuilder,
  getIsFromSeller,
  getNewbuildingName,
  getNewbuildingPromos,
  getOffer,
} from '../../selectors/newObject';

export const NewbuildingPromosSectionContainer = () => {
  const promos = useSelector(getNewbuildingPromos);
  const isFromBuilder = useSelector(getIsFromBuilder);
  const isFromSeller = useSelector(getIsFromSeller);
  const newbuildingName = useSelector(getNewbuildingName);
  const hasNewbuildingPromos = promos.length > 0;
  const offer = useSelector(getOffer);
  const newbuildingNameFormatted = newbuildingName.length > 0 ? ` «${newbuildingName}»` : '';

  const handleShow = React.useCallback(() => {
    trackPromoOffersShow({ promos, offer, isMortgagePromos: false });
  }, [offer, promos]);

  if (!(isFromBuilder || isFromSeller)) {
    return null;
  }

  const PromosComponent = hasNewbuildingPromos ? Promos : undefined;

  return (
    <ActionAfterViewObserver callback={handleShow} triggerOnce>
      <NewbuildingPromos Banner={PromosBanner} Promos={PromosComponent} newbuildingName={newbuildingNameFormatted} />
    </ActionAfterViewObserver>
  );
};

NewbuildingPromosSectionContainer.displayName = 'NewbuildingPromosSectionContainer';
